import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const bannersService = {
  addBanners,
  getBannersList,
  deleteBanners,
  getBannersDetails,
  updateBanners,
  get_SiteList
};

function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
    headerConfig.headerImage["Authorization"] = "Bearer " + token;
  }
}

function addBanners(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: propsData
  };

  return fetch(`${appConfig.api.url}banners/add`, requestOptions)
    .then(handleResponse)
    .then(banners => {
      return banners;
    });
}

function getBannersList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}banners/list`, requestOptions)
    .then(handleResponse)
    .then(banners => {
      return banners;
    });
}

function deleteBanners(bannersIdASParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(bannersIdASParams)
  };

  return fetch(
    `${appConfig.api.url}banners/delete/${bannersIdASParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(banners => {
      return banners;
    });
}

function getBannersDetails(bannersIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}banners/detail/${bannersIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(bannersDetails => {
      return bannersDetails;
    });
}

function updateBanners(propsData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: propsData
  };

  return fetch(`${appConfig.api.url}banners/edit`, requestOptions)
    .then(handleResponse)
    .then(updatedBanners => {
      return updatedBanners;
    });
}

function get_SiteList(page) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(page)
  };

  return fetch(`${appConfig.api.url}site/list`, requestOptions)
    .then(handleResponse)
    .then(sitelist => {
      return sitelist;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/bannersService.js